import React  from "react";
import { useParams } from 'react-router-dom';
import RegisteredAnimalsForm from "../components/AnimalInventoryForm";
import { ANIMAL_TYPE_CARABAO } from "variables/constants";

const EditCarabao = () => {
	const { carabaoId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<RegisteredAnimalsForm recordId={carabaoId ?? 0} mode="edit" animalTypeId={ANIMAL_TYPE_CARABAO}/>
	      </div>
	    </div>
    );
};

export default EditCarabao;